// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActivitySummaryRecordDto } from './IClaimActivitySummaryRecordDto';
import {
    IClaimActivitySummaryRecordDtoFromJSON,
    IClaimActivitySummaryRecordDtoFromJSONTyped,
    IClaimActivitySummaryRecordDtoToJSON,
    IClaimActivitySummaryRecordDtoToJSONTyped,
} from './IClaimActivitySummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoClaimActivitySummaryRecordDto
 */
export interface IReportSummaryGroupDtoClaimActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoClaimActivitySummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IClaimActivitySummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoClaimActivitySummaryRecordDto
     */
    subsidiary_records?: Array<IClaimActivitySummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoClaimActivitySummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoClaimActivitySummaryRecordDto(value: object): value is IReportSummaryGroupDtoClaimActivitySummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoClaimActivitySummaryRecordDto {
    return IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoClaimActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoClaimActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IClaimActivitySummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoClaimActivitySummaryRecordDto {
    return IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoClaimActivitySummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoClaimActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IClaimActivitySummaryRecordDtoToJSON)),
    };
}

